import { ApiProcess } from "@api/apiProcesses";
import { ProcessRunnerProcessStatusEnum } from "@api/model/processRunnerProcessStatusEnum";

const PROCESSES_CONFIG = null;

export const PROCESSES_NOTIFICATIONS_CONFIG:Record<ApiProcess, {
    name:string,
    messages:Record<ProcessRunnerProcessStatusEnum, string>
}> = {
    [ApiProcess.AssetRegisterBulkUploadProcessJob]: {
        name: 'Asset Bulk Import',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting import...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Importing assets...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Import failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Import complete',
        }
    },
    [ApiProcess.AssetRegisterDepreciationScheduleProcessJob]: {
        name: 'Assets Depreciation',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting update...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Updating postings...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Update failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Update complete',
        }
    },
    [ApiProcess.NominalLedgerEndOfYearJob]: {
        name: 'End of Year',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting update...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Updating...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Update failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Update complete',
        }
    },
    [ApiProcess.AssetRegisterReportAdditionsDisposalJob]: {
        name: 'Additions Disposal Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Additions Disposal report ready',
        }
    },
    [ApiProcess.AssetRegisterReportAssetJob]: {
        name: 'Assets Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Assets report ready',
        }
    },
    [ApiProcess.AssetRegisterReportDepreciationJob]: {
        name: 'Depreciation Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Depreciation report ready',
        }
    },
    [ApiProcess.AssetRegisterReportMovementJob]: {
        name: 'Movement Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Movement report ready',
        }
    },
    [ApiProcess.AssetRegisterReportValuationJob]: {
        name: 'Valuation Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Valuation report ready',
        }
    },
    [ApiProcess.AssetRegisterReportAuditVerificationJob]: {
        name: 'Verification Audit Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Verification Audit report ready'
        }
    },
    [ApiProcess.NominalLedgerReportBalanceSheetJob]: {
        name: 'Balance Sheet Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Balance Sheet report ready'
        }
    },
    [ApiProcess.NominalLedgerReportChartOfAccountJob]: {
        name: 'Chart Of Account Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Chart Of Account report ready'
        }
    },
    [ApiProcess.NominalLedgerReportProfitAndLossJob]: {
        name: 'Profit & Loss Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Profit & Loss report ready'
        }
    },
    [ApiProcess.NominalLedgerReportTransactionRegisterJob]: {
        name: 'Transaction Register Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Transaction Register report ready'
        }
    },
    [ApiProcess.NominalLedgerReportTrialBalanceJob]: {
        name: 'Trial Balance Report',
        messages: {
            [ProcessRunnerProcessStatusEnum.Requested]: 'Report queued',
            [ProcessRunnerProcessStatusEnum.Started]: 'Starting report generation...',
            [ProcessRunnerProcessStatusEnum.Pending]: 'Generating report...',
            [ProcessRunnerProcessStatusEnum.WithErrors]: 'Report generation failed',
            [ProcessRunnerProcessStatusEnum.Completed]: 'Trial Balance report ready'
        }
    }
} as Record<ApiProcess, {
    name:string,
    messages:Record<ProcessRunnerProcessStatusEnum, string>
}>